/**
 * Resolves which item (if any) should show unavailable section chrome.
 * Requires an explicit `unavailableItemId` signal — ordinary marketing
 * `targetItemIds` must not enable treatment chrome. Clears chrome when the
 * item is orderable at the current store (e.g. after a store change).
 */
export function resolveDeeplinkUnavailableItemId({
  unavailableItemIdParam,
  isAvailableAtStore,
}: {
  unavailableItemIdParam?: string;
  isAvailableAtStore: (id: string) => boolean;
}): string | undefined {
  if (!unavailableItemIdParam) {
    return undefined;
  }
  if (isAvailableAtStore(unavailableItemIdParam)) {
    return undefined;
  }
  return unavailableItemIdParam;
}
